/*
 |--------------------------------------------------------------------------
 | Tablist module (with tabpanels)
 |--------------------------------------------------------------------------
 */

/* ========================================================================== *\
 IMPORTS
 \* ========================================================================== */

//no imports needed

/* == END IMPORTS =========================================================== */

/* ========================================================================== *\
 CONSTANTS
 \* ========================================================================== */

const
  /**
   * The module name
   * @type {String}
   */
  moduleName = 'tablist',
  /**
   * Lookup table with class names
   * @type {Object}
   */
  classNames = {
    tabslist: `js-${moduleName}`
  },
  /**
   * Lookup table for selectors
   * @type {Object}
   */
  selectors = {
    tabslist: `.${classNames.tabslist}`
  };

/* == END CONSTANTS ========================================================= */

/* ========================================================================== *\
 SETUP TABS
 \* ========================================================================== */

class Tablist {
  constructor(element) {
    this.element = element;

    this.firstTab = null;
    this.lastTab = null;

    this.tabs = Array.from(this.element.querySelectorAll('[role=tab]'));
    this.tabpanels = [];

    this.tabs.forEach((tab) => {
      const tabpanel =  document.querySelector(tab.hash);
      this.tabpanels.push(tabpanel);

      tab.addEventListener('keydown', this.onKeydown.bind(this));
      tab.addEventListener('click', this.onClick.bind(this));

      if (!this.firstTab) {
        this.firstTab = tab;
      }
      this.lastTab = tab;
    })

    const selectedTab = this.tabs.find(tab => tab.getAttribute('aria-selected') === 'true');
    this.setSelectedTab(selectedTab || this.firstTab);
  }

  setSelectedTab(currentTab) {
    this.tabs.forEach((tab, index) => {
      if (currentTab === tab) {
        tab.setAttribute('aria-selected', 'true');
        tab.removeAttribute('tabindex');
        this.tabpanels[index].setAttribute('aria-hidden', 'false');
      } else {
        tab.setAttribute('aria-selected', 'false');
        tab.tabIndex = -1;
        this.tabpanels[index].setAttribute('aria-hidden', 'true');
      }
    });
  }

  moveFocusToTab(currentTab) {
    currentTab.focus();
  }

  moveFocusToPreviousTab(currentTab) {
    let index;

    if (currentTab === this.firstTab) {
      this.moveFocusToTab(this.lastTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.moveFocusToTab(this.tabs[index - 1]);
    }
  }

  moveFocusToNextTab(currentTab) {
    let index;

    if (currentTab === this.lastTab) {
      this.moveFocusToTab(this.firstTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.moveFocusToTab(this.tabs[index + 1]);
    }
  }

  /* EVENT HANDLERS */

  onKeydown(event) {
    const tgt = event.currentTarget;
    let key = true;

    switch (event.key) {
      case 'ArrowLeft':
        this.moveFocusToPreviousTab(tgt);
        break;

      case 'ArrowRight':
        this.moveFocusToNextTab(tgt);
        break;

      case 'Home':
        this.moveFocusToTab(this.firstTab);
        break;

      case 'End':
        this.moveFocusToTab(this.lastTab);
        break;

      default:
        key = false;
        break;
    }

    if (key) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  onClick(event) {
    event.preventDefault();
    this.setSelectedTab(event.target);
  }
}

/* == END SETUP EXPANSION PANEL ===================================================== */

/* ========================================================================== *\
 EVENT HANDLING
 \* ========================================================================== */

// No event handling needed

/* == END EVENT HANDLING ==================================================== */

/* ========================================================================== *\
 INITIALIZATION
 \* ========================================================================== */

document.querySelectorAll(selectors.tabslist).forEach((element) => {
  new Tablist(element);
})

/* == END INITIALIZATION ==================================================== */

/* ========================================================================== *\
 EXPORTS
 \* ========================================================================== */

// No exports, just default behaviour

/* == END EXPORTS ====================================================== */
